import { Link } from 'react-router-dom'

export function BtnSweetPalermo({ label = 'Así es Sweet Palermo', className = '' }) {
    return (
        <Link
            to="/sweetpalermo"
            className={`border border-[#CE3235] rounded-full my-8 inline-block" ${className}`}>
            <span className="text-[#CE3235] font-bold text-2xl px-6 py-4 inline-block">
                {label}
            </span>
        </Link>
    )
}
